import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Globals } from '../../globals';
import { ApplicationParameterGroup } from '../useractions/useractions.interface';
import { Application } from './applications.interfaces';

@Injectable({
  providedIn: 'root',
})
/**
 * Applications REST calls
 */
export class ApplicationService {
  private readonly http = inject(HttpClient);
  private readonly globals = inject(Globals);



  /**
   * Get all applications
   */
  getApplications(): Observable<Application[]> {
    const url = `${this.globals.apiRoot}/applications`;
    return this.http.get<Application[]>(url);
  }

  /**
   * Get applicationParameterGroups with given applicationId
   */
  getApplicationParameterGroups(
    id: number
  ): Observable<ApplicationParameterGroup[]> {
    const url = `${this.globals.apiRoot}/applications/${id}/groups`;
    return this.http.get<ApplicationParameterGroup[]>(url);
  }

  /**
   * Check if the user has a premium subscription
   */
  hasPremium(id: number): Observable<boolean> {
    const url = `${this.globals.apiRoot}/applications/${id}/haspremium`;
    return this.http.get<boolean>(url);
  }

  /**
   * Check if the user has a premium subscription
   */
  hasUseraction(id: number): Observable<boolean> {
    const url = `${this.globals.apiRoot}/applications/${id}/exists`;
    return this.http.get<boolean>(url);
  }
}
